/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ArticleNoteResponse } from '../../models/article-note-response';
import { KeyType } from '../../models/key-type';

export interface GetArticleNotes$Params {
  organizationSiteKey: KeyType;
  deliveryNoteKey: KeyType;
  articleKey: KeyType;
}

export function getArticleNotes(http: HttpClient, rootUrl: string, params: GetArticleNotes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ArticleNoteResponse>>> {
  const rb = new RequestBuilder(rootUrl, getArticleNotes.PATH, 'get');
  if (params) {
    rb.path('organizationSiteKey', params.organizationSiteKey, {});
    rb.path('deliveryNoteKey', params.deliveryNoteKey, {});
    rb.path('articleKey', params.articleKey, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ArticleNoteResponse>>;
    })
  );
}

getArticleNotes.PATH = '/organization-sites/{organizationSiteKey}/delivery-notes/{deliveryNoteKey}/articles/{articleKey}/notes';
